import React, { memo } from 'react'

import useTranslation from 'Pods/ThreeDStudio/Hooks/useTranslation'

import arrowImage from 'images/three_d_studio/edit-empty-arrow.svg'

// Shown in the Edit tab until an image is handed in from Search or Create. The
// decorative arrow points back up to the Search/Create tabs; it is the Figma
// asset rotated as a unit (see SCSS) and hidden from assistive tech.
function EmptyState() {
  const t = useTranslation()

  return (
    <div className="image-assistant-edit-tab__empty">
      <img className="image-assistant-edit-tab__empty-arrow" src={arrowImage} alt="" aria-hidden="true" />
      <div className="image-assistant-edit-tab__empty-text">
        <p className="image-assistant-edit-tab__empty-title cgt-heading-50">
          {t('imageAssistantPanel.editTab.emptyState.title')}
        </p>
        <p className="image-assistant-edit-tab__empty-subtitle cgt-body-base">
          {t('imageAssistantPanel.editTab.emptyState.subtitle')}
        </p>
      </div>
    </div>
  )
}

export default memo(EmptyState)
